import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  readonly isMobileOrTablet: boolean = this.detectMobileOrTablet();
  readonly isMobile: boolean = this.detectMobile();
  readonly isTablet: boolean = this.detectTablet();

  private detectMobileOrTablet(): boolean {
    // Modern User Agent Client Hints API (preferred)
    if ('userAgentData' in navigator) {
      const uaData = (navigator as any).userAgentData;
      if (uaData?.mobile) {
        return true;
      }
    }

    // Fallback to User Agent string parsing
    const userAgent = navigator.userAgent || navigator.vendor;

    // Detect modern mobile and tablet devices
    const mobileRegex = /android|iphone|ipod|ipad/i;
    if (mobileRegex.test(userAgent)) {
      return true;
    }

    // iPad on iOS 13+ detection (reports as MacIntel)
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      return true;
    }

    return false;
  }

  private detectMobile(): boolean {
    // Modern User Agent Client Hints API (preferred)
    if ('userAgentData' in navigator) {
      const uaData = (navigator as any).userAgentData;
      // Check if mobile and not a tablet
      if (uaData?.mobile && !this.detectTablet()) {
        return true;
      }
    }

    const userAgent = navigator.userAgent || navigator.vendor;

    // Detect mobile phones (not tablets)
    // iPhone and iPod are mobile phones
    if (/iphone|ipod/i.test(userAgent)) {
      return true;
    }

    // Android mobile (has "Mobile" in user agent, tablets don't)
    if (/android/i.test(userAgent) && /mobile/i.test(userAgent)) {
      return true;
    }

    return false;
  }

  private detectTablet(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;

    // iPad detection
    if (/ipad/i.test(userAgent)) {
      return true;
    }

    // iPad on iOS 13+ detection (reports as MacIntel)
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      return true;
    }

    // Android tablet (has Android but NOT "Mobile" in user agent)
    if (/android/i.test(userAgent) && !/mobile/i.test(userAgent)) {
      return true;
    }

    return false;
  }
}
